<template>
  <div>
    <!--begin::Hero-->
    <div class="card card-custom position-relative overflow-hidden mb-8">
      <div
        class="
          position-absolute
          bottom-0
          left-0
          right-0
          d-none d-lg-flex
          flex-row-fluid
        "
      >
        <span
          class="svg-icon svg-icon-full flex-row-fluid svg-icon-dark opacity-3"
        >
          <!--begin::Svg Icon | path:assets/media/bg/home-2-bg.svg-->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 1200 172"
            style="enable-background: new 0 0 1200 172"
            xml:space="preserve"
          >
            <path
              class="st0"
              d="M2058,94c0,0,16-14,73-14s153,92,248,92s286-145,456-145s183,34,292,34s131-54,131-54v172H2058V94z"
            />
            <path
              class="st0"
              d="M0,87c0,0,16-14,73-14s153,92,248,92S607,20,777,20s183,34,292,34s131-54,131-54v172H0V87z"
            />
          </svg>
          <!--end::Svg Icon-->
        </span>
      </div>
      <div
        class="
          position-absolute
          d-flex
          top-0
          right-0
          offset-lg-6
          col-lg-6
          opacity-30 opacity-lg-100
        "
      >
        <inline-svg src="media/svg/illustrations/vaccinations.svg" />
      </div>
      <div class="card-body" style="padding-bottom: 3.5rem">
        <div class="col-lg-6">
          <div class="align-items-center flex-wrap py-25 px-5">
            <!--begin::Heading-->
            <h2 class="text-dark font-weight-bolder mr-12">3M Monitoring</h2>
            <div class="h4 text-dark-50">
              Mencuci Tangan, Memakai Masker, dan Menjaga Jarak
            </div>
            <!--end::Heading-->
          </div>
        </div>
      </div>
    </div>
    <!--end::Hero-->

    <h4 class="text-dark mt-10 mb-5">Dashboard Provinsi</h4>
    <div class="row">
      <div class="col-lg-6">
        <!--begin::Card-->
        <div class="card card-custom p-6 mb-8 mb-lg-0">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-7">
                <!--begin::Content-->
                <h2 class="text-dark mb-4">3M Jawa Tengah</h2>
                <p class="text-dark-50 font-size-lg">
                  Monitoring kegiatan 3M untuk wilayah Jawa Tengah
                </p>
                <!--end::Content-->
              </div>
              <div
                class="
                  col-sm-5
                  d-flex
                  align-items-center
                  justify-content-sm-end
                "
              >
                <!--begin::Button-->
                <router-link to="/jateng" v-slot="{ href, navigate }">
                  <a
                    :href="href"
                    @click="navigate"
                    class="
                      btn
                      font-weight-bolder
                      text-uppercase
                      font-size-lg
                      btn-primary
                      py-3
                      px-6
                    "
                  >
                    Visit
                  </a>
                </router-link>
                <!--end::Button-->
              </div>
            </div>
          </div>
        </div>
        <!--end::Card-->
      </div>
      <div class="col-lg-6">
        <!--begin::Card-->
        <div class="card card-custom p-6">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-7">
                <!--begin::Content-->
                <h2 class="text-dark mb-4">3M NTT</h2>
                <p class="text-dark-50 font-size-lg">
                  Monitoring kegiatan 3M untuk wilayah Nusa Tenggara Timur
                </p>
                <!--end::Content-->
              </div>
              <div
                class="
                  col-sm-5
                  d-flex
                  align-items-center
                  justify-content-sm-end
                "
              >
                <!--begin::Button-->
                <router-link to="/ntt" v-slot="{ href, navigate }">
                  <a
                    :href="href"
                    @click="navigate"
                    class="
                      btn
                      font-weight-bolder
                      text-uppercase
                      font-size-lg
                      btn-success
                      py-3
                      px-6
                    "
                  >
                    Visit
                  </a>
                </router-link>
                <!--end::Button-->
              </div>
            </div>
          </div>
        </div>
        <!--end::Card-->
      </div>
    </div>

    <!-- <pre class="language-json"><code>{{ this.trendData }}</code></pre> -->
  </div>
</template>

<script>
export default {
  name: 'home',
}
</script>
